/**
 * MAX SDK compatibility layer
 * Заменяет @telegram-apps/sdk-react для работы в MAX
 * MAX SDK загружается через <script src="https://st.max.ru/js/max-web-app.js">
 * и создаёт window.WebApp с совместимым Telegram WebApp API
 */

declare global {
  interface Window {
    WebApp: any
  }
}

const wa = () => window.WebApp

// --- Launch Params ---
export function retrieveLaunchParams() {
  return {
    startParam: wa()?.initDataUnsafe?.start_param || '',
    initData: wa()?.initDataUnsafe || {},
  }
}

export function useLaunchParams() {
  return {
    startParam: wa()?.initDataUnsafe?.start_param || '',
    initData: wa()?.initDataUnsafe || {},
  }
}

// --- isTMA ---
export async function isTMA(): Promise<boolean> {
  if (wa()) return true
  // MAX SDK может загружаться асинхронно — подождём до 2 секунд
  return new Promise((resolve) => {
    let attempts = 0
    const check = () => {
      if (wa()) return resolve(true)
      if (++attempts > 20) return resolve(false)
      setTimeout(check, 100)
    }
    check()
  })
}

// --- Back Button ---
export const backButton = {
  isSupported: () => true,
  isMounted: () => true,
  mount: () => {},
  show: () => wa()?.BackButton?.show(),
  hide: () => wa()?.BackButton?.hide(),
  onClick: (fn: () => void) => wa()?.BackButton?.onClick(fn),
  offClick: (fn: () => void) => wa()?.BackButton?.offClick(fn),
}

// --- Mini App ---
export const miniApp = {
  mount: () => {},
  bindCssVars: () => {},
}

// --- Init Data ---
export const initData = {
  restore: () => {},
}

// --- Viewport ---
export const viewport = {
  mount: () => Promise.resolve(),
  bindCssVars: () => {},
}

// --- Theme ---
export const themeParams = {
  mount: () => {},
  bindCssVars: () => {},
}

export function isThemeParamsDark(): boolean {
  const color = wa()?.themeParams?.bg_color
  if (!color) return false
  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return (r * 299 + g * 587 + b * 114) / 1000 < 128
}

export function isColorDark(rgb: string): boolean {
  const match = rgb.match(/(\d+),\s*(\d+),\s*(\d+)/)
  if (!match) return false
  const [, r, g, b] = match.map(Number)
  return (r * 299 + g * 587 + b * 114) / 1000 < 128
}

// --- Events ---
type EventCallback = (payload: any) => void
const listeners: Record<string, EventCallback[]> = {}

export function on(event: string, callback: EventCallback) {
  if (!listeners[event]) listeners[event] = []
  listeners[event].push(callback)
  return () => {
    listeners[event] = listeners[event].filter(cb => cb !== callback)
  }
}

export function postEvent(eventType: string, eventData?: any) {
  try {
    wa()?.postEvent?.(eventType, eventData)
  } catch {}
}

// --- Swipe behavior ---
export const swipeBehavior = {
  isMounted: () => false,
}

export function disableVerticalSwipes() {}

export function defineEventHandlers() {}

// --- Links ---
export function openLink(url: string) {
  wa()?.openLink?.(url) || window.open(url, '_blank')
}

export function openTelegramLink(url: string) {
  // В MAX нет openTelegramLink, просто открываем ссылку
  wa()?.openLink?.(url) || window.open(url, '_blank')
}

// --- SDK Init ---
export function init() {}

export const $debug = {
  set: (_v: boolean) => {},
}
